import { Injectable } from '@angular/core';
import { getUploadUrl } from '@app/api/Upload';
import { RootReducer, Store } from '@app/app.reducers';
import { FileUploadStatus, finishUpload, startUpload } from '@app/shared/reducers/upload.reducer';
import { NewRelic } from '@app/shared/services/newrelic.service';

@Injectable({ providedIn: 'root' })
export class AwsUploadService {
	constructor(
		private readonly store: Store<RootReducer.State>,
		private readonly newRelic: NewRelic,
	) {}

	async upload(key: string, file: File): Promise<Response> {
		this.store.dispatch(startUpload(key));

		try {
			const uploadConfig = await getUploadUrl({ body: { key } });
			const url = uploadConfig?.data?.url;
			if (!url) throw new Error('Failed to get upload url');
			const fields = uploadConfig?.data?.fields;
			const formData = this.buildFormData(key, file, fields);
			const response = await fetch(url, {
				body: formData,
				method: 'POST',
				mode: 'cors',
			});
			if (!response.ok) throw await response.text();
			this.store.dispatch(finishUpload(key, FileUploadStatus.Success));
			return response;
		} catch (err) {
			this.store.dispatch(finishUpload(key, FileUploadStatus.Error));
			this.newRelic.noticeError(err);
		}
	}

	private buildFormData(key: string, file: File, fields: any): FormData {
		const formData = new FormData();
		for (const field of Object.keys(fields)) {
			formData.append(field, fields[field]);
		}
		formData.append('file', file, key);
		return formData;
	}
}
